import { brewMenuSubscriptionFragment } from "utilities/src/graphql/fragments/brewmenu"

export const superAdminUpdateBrewMenuSubscriptionMutation = /* GraphQL */ `mutation SuperAdminUpdateBrewMenuSubscription($input: inputSuperAdminUpdateBrewMenuSubscription!) {
	superAdminUpdateBrewMenuSubscription(input: $input){
    ...${brewMenuSubscriptionFragment}
  }`
